export const isEmptyText = (value: string) => {
  return value !== '' && value.trim() === '';
};
